import { IconCompassCalibration } from "@aws-amplify/ui-react";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { PlayerMode, selectPlayer } from "../../../features/player/playerSlice";
import { selectTheme, ThemeMode } from "../../../features/theme/themeSlice";

type HeaderIcon = {
  id: number;
  ico: string;
  label: string;
  enabled: boolean;
  route: string;
  visibleweb: boolean;
  visiblekiosk: boolean;
  showLabel: boolean;
  showLabelkiosk?: boolean;
  cssClass?: string;
};

const HeaderIcons: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const player = useAppSelector(selectPlayer);
  const theme = useAppSelector(selectTheme);
  const location = useLocation();

  const icons: Array<HeaderIcon> = [
    {
      id: 3,
      ico: "ico_sport.png",
      label: intl.formatMessage({ id: "tabs.sport" }),
      enabled: true,
      route: "sport",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },
    {
      id: 4,
      ico: "ico_sportlive.png",
      label: intl.formatMessage({ id: "tabs.sportlive" }),
      enabled: true,
      route: "sportlive",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },
    {
      id: 2,
      ico: "ico_virtuali.png",
      label: intl.formatMessage({ id: "tabs.virtual" }),
      enabled: true,
      route: "virtual",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },

    {
      id: 5,
      ico: "ico_casino.png",
      label: intl.formatMessage({ id: "tabs.casino" }),
      enabled: true,
      route: "casino",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },
    {
      id: 6,
      ico: "ico_casinolive.png",
      label: intl.formatMessage({ id: "tabs.casinolive" }),
      enabled: true,
      route: "live-casino",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
      cssClass: "ico80",
    },
    {
      id: 7,
      ico: "ico_poker.png",
      label: intl.formatMessage({ id: "tabs.poker" }),
      enabled: true,
      route: "poker",
      visibleweb: true,
      visiblekiosk: false,
      showLabel: theme.isTablet ? true : false,
    },
    {
      id: 1,
      ico: "ico_lotterie.png",
      label: intl.formatMessage({ id: "tabs.lottery" }),
      enabled: true,
      route: "lottery",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },
    /* {
      id: 8,
      ico: "ico_skillgames.png",
      label: intl.formatMessage({ id: "tabs.skillgames" }),
      enabled: true,
      route: "skillgames",
      visibleweb: true,
      visiblekiosk: false,
      showLabel: false,
    }, */
    {
      id: 9,
      ico: "ico_turf.png",
      label: intl.formatMessage({ id: "tabs.ippica" }),
      enabled: true,
      route: "horseracing",
      visibleweb: true,
      visiblekiosk: true,
      showLabel: theme.isTablet ? true : false,
      showLabelkiosk: true,
    },
    /*  {
      id: 10,
      ico: "ico_promo.png",
      label: intl.formatMessage({ id: "tabs.promo" }),
      enabled: true,
      route: "promo",
      visibleweb: true,
      visiblekiosk: false,
      showLabel: false,
    }, */
  ];

  if (player.mode === PlayerMode.KIOSK) {
    return (
      <div className="d-nav-icons d-flex f-row">
        <div
          className={`pointer text-center d-header-icon ${
            location.pathname === "/" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/");
          }}
          title="Home"
        >
          <img
            src={`images/icons/ico_home.png`}
            alt="Go Home"
            className={`header-ico ico24px ${
              location.pathname === "/" ? "active" : ""
            }`}
          />
          <br />
          <span className="icons-label">Home</span>
        </div>
        <div
          className="pointer text-center"
          onClick={() => {
            navigate(-1);
          }}
          title="Go back"
        >
          <img
            src={`images/icons/ico_goback.png`}
            alt="Go Back"
            className="header-ico ico24px"
          />
          <br />
          <span className="icons-label">
            <FormattedMessage id="Go Back" />
          </span>
        </div>
        {icons.map((ico, i) => {
          return ico.visiblekiosk ? (
            <div
              key={`ico-${ico.label}`}
              className={`pointer text-center d-header-icon ${
                location.pathname.split("/")[1] === ico.route ? "active" : ""
              } ${ico.cssClass ? ico.cssClass : ""}`}
              onClick={() => {
                if (ico.enabled) navigate(ico.route);
              }}
              title={ico.label}
            >
              <img
                src={`images/icons/${ico.ico}`}
                alt={ico.label}
                className={`header-ico ico24px ${
                  location.pathname.split("/")[1] === ico.route ? "active" : ""
                }`}
              />
              <br />
              {ico.showLabelkiosk && (
                <span className="icons-label">{ico.label}</span>
              )}
            </div>
          ) : (
            ""
          );
        })}
      </div>
    );
  }

  return (
    <div className="d-nav-icons d-flex f-row">
      <div
        className={`pointer text-center d-header-icon ${
          location.pathname === "/" ? "active" : ""
        }`}
        onClick={() => {
          navigate("/");
        }}
        title="Home"
      >
        <img
          src={`images/icons/ico_home.png`}
          alt="Go Home"
          className={`header-ico ico24px ${
            location.pathname === "/" ? "active" : ""
          }`}
        />
        <br />
        {theme.isTablet && <span className="icons-label">Home</span>}
      </div>
      {icons.map((ico, i) => {
        return ico.visibleweb ? (
          <div
            key={`ico-${ico.label}`}
            className={`pointer text-center d-header-icon ${
              location.pathname.split("/")[1] === ico.route ? "active" : ""
            } ${ico.cssClass ? ico.cssClass : ""}`}
            onClick={() => {
              if (ico.enabled) navigate(ico.route);
            }}
            title={ico.label}
          >
            <img
              src={`images/icons/${ico.ico}`}
              alt={ico.label}
              className={`header-ico ico24px ${
                location.pathname.split("/")[1] === ico.route ? "active" : ""
              }`}
            />
            <br />
            {ico.showLabel && <span className="icons-label">{ico.label}</span>}
          </div>
        ) : (
          ""
        );
      })}
    </div>
  );
};

export default HeaderIcons;
